export default __webpack_public_path__ + "static/media/mar2024-4.e303513f.jpg";